import { t } from 'i18next'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React from 'react'

export const FilterElement = (props: {
  id: string;
  globalFilter: string;
  setGlobalFilter: (value: string) => void;
  resetFilter: () => void;
}) => {
  return (
    <div
      id={props.id}
      className={'inline-flex justify-content-center align-items-center gap-1'}
    >
      <span className={'p-input-icon-left'}>
        <i className="pi pi-filter" />
        <InputText
          id={'search-input'}
          className={'search-input'}
          value={props.globalFilter}
          placeholder={t<string>('core.filter')}
          onChange={(e: any) => props.setGlobalFilter(e.target.value)}
        />
      </span>
      <Button
        type="button"
        className={'p-button-text ml-0'}
        icon="pi pi-filter-slash"
        tooltip={t<string>('core.reset_filter')}
        tooltipOptions={{ showDelay: 800 }}
        onClick={() => props.resetFilter()}
      />
    </div>
  )
}